// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M9.29434 22H22V18.1952L11.5196 13.4698L9.29434 22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 16.0013V2H14.5117L12.0317 11.5068L22 16.0013Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M12.4448 2H2V22H7.2274L12.4448 2Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-collage-filled')
export default class CollageFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'collage-filled',
    }
  }
}
